import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSortDescendingAlt';
/** Renders an SVG icon. */
const SvgSortDescendingAlt = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.05 6.57a1.25 1.25 0 0 1 1.9 0l5.456 6.366c.695.811.118 2.064-.95 2.064H10.544c-1.068 0-1.645-1.253-.95-2.064l5.457-6.365ZM12.175 13h7.652L16 8.536 12.174 13Zm-2.58 6.063c-.695-.81-.118-2.063.95-2.063h10.912c1.068 0 1.645 1.253.95 2.063l-5.457 6.366a1.25 1.25 0 0 1-1.898 0z"
      />
    </svg>
  );
};
SvgSortDescendingAlt.displayName = displayName;
export default SvgSortDescendingAlt;
